export const INCLUDE_UNIFY_PATHS = [
  "/blog/free-zendesk/alternatives/",
  "/blog/help-scout-vs-intercom/",
  "/blog/hubspot-alternatives/",
  "/blog/intercom-alternatives/",
  "/blog/zendesk-alternative/",
  "/blog/zendesk-alternatives/",
  "/compare/hubspot/",
  "/compare/intercom/",
  "/compare/zendesk/",
  "/lp/get-a-demo/",
]
